import React, { useEffect } from 'react';

import { JRCHtml } from 'components/JRCHtml/JRCHtml';
import { WidgetArticleTitleContent, WidgetDisplayMode } from 'jamespot-user-api';
import { CSSTextareaWrapper, CSSWrapperText, StyledTextarea } from '../styles';
import { useIntl } from 'react-intl';
import { Typography } from 'components/JRCTypography/JRCTypography.styles';

const limit = 255;

export const JRCWidgetArticleTitle = ({
    text,
    color,
    heading,
    autoFocus,
    inplace,
    mode,
    onChange,
    dataCy,
}: WidgetArticleTitleContent & {
    autoFocus: boolean;
    inplace: boolean;
    mode?: WidgetDisplayMode;
    onChange: (text: string) => void;
}) => {
    const intl = useIntl();
    const inputRef = React.useRef<HTMLTextAreaElement>(null);
    const [limitCharacters, setLimitCharacters] = React.useState<number>(limit);
    useEffect(() => {
        if (autoFocus) {
            inputRef.current?.focus();
        } else {
            inputRef.current?.blur();
        }
    }, [autoFocus]);

    const doSetInnerText = React.useCallback(
        (text: string) => {
            onChange(text);
            setLimitCharacters(limit - text.length);
        },
        [onChange],
    );

    if (inplace && mode === 'edit') {
        return (
            <CSSTextareaWrapper>
                <Typography size="s">{limitCharacters}</Typography>
                <StyledTextarea heading={heading} color={color}>
                    <textarea
                        data-cy={dataCy}
                        ref={inputRef}
                        data-form-type="other"
                        maxLength={limit}
                        defaultValue={text}
                        placeholder={intl.formatMessage({ id: 'WIDGET_Article_Title_Placeholder' })}
                        onChange={(event) => doSetInnerText(event.currentTarget.value)}></textarea>
                </StyledTextarea>
            </CSSTextareaWrapper>
        );
    }

    return (
        <CSSWrapperText color={color} heading={heading}>
            <JRCHtml __html={text ?? ''} />
        </CSSWrapperText>
    );
};
